var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 h-100 shadow d-flex justify-content-center align-items-center flex-column"},[_c('h6',[_vm._v("Hedge Wallet Amount")]),_c('h2',{staticClass:"font-weight-bolder mb-1"},[_vm._v(_vm._s(_vm.hedgeWalletAmount))])])}
var staticRenderFns = []

export { render, staticRenderFns }